import "core-js/modules/es.array.join.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("wlc-breadcrumb"), _c("div", {
    staticClass: "wlc-space-between"
  }, [_c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm,
      size: "small"
    },
    nativeOn: {
      submit: function submit($event) {
        $event.preventDefault();
      }
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "房源地址"
    }
  }, [_c("el-select", {
    attrs: {
      multiple: ""
    },
    on: {
      change: _vm.getDistrictList
    },
    model: {
      value: _vm.searchForm.cityId,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "cityId", $$v);
      },
      expression: "searchForm.cityId"
    }
  }, _vm._l(_vm.filterList.cityList, function (item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        label: item.name,
        value: item.id
      }
    });
  }), 1)], 1), _c("el-form-item", [_c("el-select", {
    attrs: {
      multiple: ""
    },
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.districtId,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "districtId", $$v);
      },
      expression: "searchForm.districtId"
    }
  }, _vm._l(_vm.districtList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.name,
        value: item.id
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: ""
    }
  }, [_c("el-radio-group", {
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.new,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "new", $$v);
      },
      expression: "searchForm.new"
    }
  }, [_c("el-radio-button", {
    attrs: {
      label: ""
    }
  }, [_vm._v("All")]), _c("el-radio-button", {
    attrs: {
      label: "1"
    }
  }, [_vm._v("New")]), _c("el-radio-button", {
    attrs: {
      label: "2"
    }
  }, [_vm._v("Renew")])], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "手机号"
    }
  }, [_c("el-input", {
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "phone", $$v);
      },
      expression: "searchForm.phone"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "房东姓名"
    }
  }, [_c("el-input", {
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.name,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "name", $$v);
      },
      expression: "searchForm.name"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "审核人员"
    }
  }, [_c("el-select", {
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.adminId,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "adminId", $$v);
      },
      expression: "searchForm.adminId"
    }
  }, _vm._l(_vm.adminList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.name,
        value: item.id
      }
    });
  }), 1)], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.getData("search");
      }
    }
  }, [_vm._v("搜索")]), _c("el-button", {
    attrs: {
      type: "warning"
    },
    on: {
      click: function click($event) {
        _vm.searchForm = {
          pn: 1,
          ps: 20,
          new: ""
        };
        _vm.$router.replace({
          query: {}
        });
        _vm.getData("search");
      }
    }
  }, [_vm._v("重置")]), _c("el-popover", {
    staticClass: "wlc-table-column-filter",
    attrs: {
      placement: "bottom",
      width: "160"
    },
    model: {
      value: _vm.tableColumnFilterVisible,
      callback: function callback($$v) {
        _vm.tableColumnFilterVisible = $$v;
      },
      expression: "tableColumnFilterVisible"
    }
  }, [_vm._l(_vm.tableColumn, function (item, index) {
    return _c("div", {
      key: index
    }, [_c("el-checkbox", {
      model: {
        value: item.visible,
        callback: function callback($$v) {
          _vm.$set(item, "visible", $$v);
        },
        expression: "item.visible"
      }
    }, [_vm._v(_vm._s(item.name))])], 1);
  }), _c("el-button", {
    attrs: {
      slot: "reference",
      icon: "el-icon-s-grid",
      circle: ""
    },
    slot: "reference"
  })], 2)], 1)], 1), _c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm
    }
  })], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.tableLoading,
      expression: "tableLoading"
    }],
    ref: "filterTable",
    attrs: {
      data: _vm.tableData,
      border: "",
      "row-class-name": _vm.tableRowClassName
    },
    on: {
      "header-dragend": _vm.tableHeaderDragend
    }
  }, [_vm.tableColumn.houseCode.visible ? _c("el-table-column", {
    attrs: {
      label: "房源编号",
      "column-key": "houseCode",
      width: _vm.tableColumn.houseCode.width
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.userInfo.scene == 2 ? _c("el-tag", {
          attrs: {
            type: "success",
            size: "small"
          }
        }, [_vm._v("城市大使")]) : _vm._e(), _c("wlc-house-table-number", {
          attrs: {
            number: scope.row.houseCode,
            id: scope.row.id
          }
        }), scope.row.userInfo.logoutCount > 0 ? _c("el-tag", {
          attrs: {
            size: "small",
            type: "danger"
          }
        }, [_vm._v("注销+" + _vm._s(scope.row.userInfo.logoutCount))]) : _vm._e()];
      }
    }], null, false, 2214674307)
  }) : _vm._e(), _vm.tableColumn.userName.visible ? _c("el-table-column", {
    attrs: {
      label: "姓名",
      "column-key": "userName",
      width: _vm.tableColumn.userName.width
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var _ref$row = _ref.row,
          userInfo = _ref$row.userInfo,
          newUser = _ref$row.newUser,
          deviceRiskInfo = _ref$row.deviceRiskInfo;
        return [_c("wlc-user-pop", {
          attrs: {
            info: newUser,
            deviceRisk: "",
            deviceRiskInfo: deviceRiskInfo
          },
          on: {
            saveRemark: _vm.saveRemark
          }
        }), _c("wlc-pop-radar-chart", {
          attrs: {
            info: userInfo.userScore,
            type: userInfo.user_type
          }
        })];
      }
    }], null, false, 162866849)
  }) : _vm._e(), _vm.tableColumn.remark.visible ? _c("el-table-column", {
    attrs: {
      label: "备注",
      "column-key": "remark",
      width: _vm.tableColumn.remark.width
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("wlc-remark-list", {
          attrs: {
            remarkList: scope.row.userInfo.remarkList,
            remark: scope.row.userInfo.remark
          }
        })];
      }
    }], null, false, 1610041351)
  }) : _vm._e(), _vm.tableColumn.imCount.visible ? _c("el-table-column", {
    attrs: {
      prop: "imCount",
      label: "消息数",
      "column-key": "imCount",
      width: _vm.tableColumn.imCount.width
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-button", {
          attrs: {
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.goConversationList(scope.row);
            }
          }
        }, [_vm._v(_vm._s(scope.row.imCount))])];
      }
    }], null, false, 2451919132)
  }) : _vm._e(), _vm.tableColumn.userPhone.visible ? _c("el-table-column", {
    attrs: {
      prop: "userInfo.phone",
      label: "手机号",
      "column-key": "userPhone",
      width: _vm.tableColumn.userPhone.width
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.userInfo.isVirtualNumber ? _c("el-tag", {
          staticClass: "mr8 wlc-important-tag",
          attrs: {
            size: "small",
            type: "danger"
          }
        }, [_vm._v("虚拟号")]) : _vm._e(), _c("div", [_vm._v(_vm._s(scope.row.userInfo.phone))])];
      }
    }], null, false, 1651817973)
  }) : _vm._e(), _vm.tableColumn.address.visible ? _c("el-table-column", {
    attrs: {
      prop: "address",
      label: "详细地址",
      "column-key": "address",
      width: _vm.tableColumn.address.width
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("wlc-house-table-address", {
          attrs: {
            address: scope.row.address,
            addressList: scope.row.addressArr
          }
        })];
      }
    }], null, false, 1193232197)
  }) : _vm._e(), _vm.tableColumn.userTag.visible ? _c("el-table-column", {
    attrs: {
      prop: "userTag",
      label: "用户标签",
      "column-key": "userTag",
      width: _vm.tableColumn.userTag.width
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("wlc-user-table-tag", {
          attrs: {
            userId: scope.row.userInfo.id,
            list: scope.row.userTag
          }
        })];
      }
    }], null, false, 4221986230)
  }) : _vm._e(), _vm.tableColumn.realName.visible ? _c("el-table-column", {
    attrs: {
      label: "实名信息",
      "column-key": "realName",
      width: _vm.tableColumn.realName.width
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-popover", {
          attrs: {
            placement: "top-start",
            content: scope.row.userInfo.auth_info.idcard_number,
            trigger: "hover"
          }
        }, [_c("el-link", {
          attrs: {
            slot: "reference",
            type: "danger"
          },
          slot: "reference"
        }, [_vm._v(_vm._s(scope.row.userInfo.auth_info.idcard_name) + " "), scope.row.userInfo.auth_info_account.length > 1 ? _c("span", [_vm._v("* " + _vm._s(scope.row.userInfo.auth_info_account.length))]) : _vm._e()])], 1)];
      }
    }], null, false, 419143516)
  }) : _vm._e(), _vm.tableColumn.authInfo.visible ? _c("el-table-column", {
    attrs: {
      label: "认证信息",
      "column-key": "authInfo",
      width: _vm.tableColumn.authInfo.width
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.authPay != 0 ? _c("wlc-house-auth-info", {
          attrs: {
            houseId: scope.row.id
          }
        }) : _vm._e()];
      }
    }], null, false, 908580777)
  }) : _vm._e(), _vm.tableColumn.houseTag.visible ? _c("el-table-column", {
    attrs: {
      label: "房源标签",
      "column-key": "houseTag",
      width: _vm.tableColumn.houseTag.width
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.typeTags.length == 0 ? _c("span", [_vm._v("无")]) : _vm._e(), _c("span", [_vm._v(_vm._s(scope.row.typeTags.join("、")))])];
      }
    }], null, false, 2404337480)
  }) : _vm._e(), _vm.tableColumn.rent.visible ? _c("el-table-column", {
    attrs: {
      prop: "rent",
      label: "租金",
      "column-key": "rent",
      width: _vm.tableColumn.rent.width
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(_vm._s(scope.row.rent))];
      }
    }], null, false, 3918890448)
  }) : _vm._e(), _vm.tableColumn.deposit.visible ? _c("el-table-column", {
    attrs: {
      prop: "deposit",
      label: "押金",
      "column-key": "deposit",
      width: _vm.tableColumn.deposit.width
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(_vm._s(scope.row.deposit))];
      }
    }], null, false, 1505481517)
  }) : _vm._e(), _vm.tableColumn.rentType.visible ? _c("el-table-column", {
    attrs: {
      prop: "rentType",
      label: "租房类型",
      "column-key": "rentType",
      width: _vm.tableColumn.rentType.width
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(_vm._s(scope.row.rentType))];
      }
    }], null, false, 1306607208)
  }) : _vm._e(), _vm.tableColumn.district.visible ? _c("el-table-column", {
    attrs: {
      prop: "district",
      label: "地区",
      "column-key": "district",
      width: _vm.tableColumn.district.width
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(_vm._s(scope.row.district))];
      }
    }], null, false, 3458883771)
  }) : _vm._e(), _vm.tableColumn.status.visible ? _c("el-table-column", {
    attrs: {
      prop: "status",
      label: "状态",
      "column-key": "status",
      width: _vm.tableColumn.status.width
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.status === 1 ? _c("span", [_vm._v("待审核")]) : _vm._e(), scope.row.status === 2 ? _c("span", [_vm._v("认证中")]) : _vm._e(), scope.row.status === 3 ? _c("span", [_vm._v("待确认认证")]) : _vm._e()];
      }
    }], null, false, 4265381011)
  }) : _vm._e(), _vm.tableColumn.create.visible ? _c("el-table-column", {
    attrs: {
      prop: "create",
      label: "发布时间",
      "column-key": "create",
      width: _vm.tableColumn.create.width
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(_vm._s(scope.row.create))];
      }
    }], null, false, 330292665)
  }) : _vm._e(), _vm.tableColumn.update.visible ? _c("el-table-column", {
    attrs: {
      prop: "update",
      label: "编辑时间",
      "column-key": "update",
      width: _vm.tableColumn.update.width
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(_vm._s(scope.row.update))];
      }
    }], null, false, 1412670636)
  }) : _vm._e(), _vm.tableColumn.loginTime.visible ? _c("el-table-column", {
    attrs: {
      prop: "userInfo.loginTime",
      label: "登录时间",
      "column-key": "loginTime",
      width: _vm.tableColumn.loginTime.width
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(_vm._s(scope.row.userInfo.loginTime))];
      }
    }], null, false, 2770975450)
  }) : _vm._e(), _vm.tableColumn.adminUser.visible ? _c("el-table-column", {
    attrs: {
      prop: "adminUser.name",
      label: "审核人员",
      "column-key": "adminUser",
      width: _vm.tableColumn.adminUser.width
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(_vm._s(scope.row.adminUser.name))];
      }
    }], null, false, 1177172458)
  }) : _vm._e(), _c("el-table-column", {
    attrs: {
      label: "操作",
      align: "center",
      width: "160",
      fixed: "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-button", {
          attrs: {
            type: "text",
            size: "mini"
          },
          on: {
            click: function click($event) {
              return _vm.updateItem(scope.row);
            }
          }
        }, [_vm._v("编辑")]), _c("el-button", {
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.goChat(scope.row);
            }
          }
        }, [_vm._v(" 聊天 ")]), _c("el-button", {
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.setRemarkDialog(scope.row.userInfo);
            }
          }
        }, [_vm._v(" 备注 ")]), _c("br"), scope.row.status == 1 ? _c("wlc-set-house-type", {
          attrs: {
            className: "wlc-button-danger",
            userId: scope.row.userInfo.id,
            houseId: scope.row.id,
            houseType: 2
          },
          on: {
            refresh: _vm.getData
          }
        }) : _vm._e(), scope.row.userInfo.user_type == 0 ? _c("wlc-set-user-type", {
          attrs: {
            className: "wlc-button-danger",
            houseId: scope.row.id,
            userId: scope.row.userInfo.id,
            userType: 1
          },
          on: {
            refresh: _vm.getData
          }
        }) : _vm._e(), scope.row.userInfo.user_type == 0 ? _c("wlc-set-user-type", {
          attrs: {
            className: "wlc-button-danger",
            houseId: scope.row.id,
            userId: scope.row.userInfo.id,
            userType: 3
          },
          on: {
            refresh: _vm.getData
          }
        }) : _vm._e(), _c("br"), scope.row.status == 1 ? _c("wlc-house-pass-button", {
          attrs: {
            className: "wlc-button-succes",
            size: "mini",
            type: "text",
            houseId: scope.row.id,
            userId: scope.row.userInfo.id
          },
          on: {
            refresh: _vm.getData
          }
        }) : _vm._e(), scope.row.status == 1 || scope.row.status == 3 ? _c("wlc-house-reject-button", {
          attrs: {
            size: "mini",
            type: "text",
            houseId: scope.row.id,
            userId: scope.row.userInfo.id
          },
          on: {
            refresh: _vm.getData
          }
        }) : _vm._e()];
      }
    }])
  })], 1), _c("div", {
    staticClass: "wlc-pagination"
  }, [!_vm.tableLoading ? _c("el-pagination", {
    attrs: {
      layout: "total, prev, pager, next",
      "page-size": _vm.searchForm.ps,
      "current-page": _vm.searchForm.pn,
      total: _vm.total
    },
    on: {
      "update:currentPage": function updateCurrentPage($event) {
        return _vm.$set(_vm.searchForm, "pn", $event);
      },
      "update:current-page": function updateCurrentPage($event) {
        return _vm.$set(_vm.searchForm, "pn", $event);
      },
      "current-change": _vm.pageChange
    }
  }) : _vm._e()], 1), _c("wlc-remark", {
    attrs: {
      visible: _vm.remarkDialogVisible,
      userId: _vm.currentRemarkObj.id,
      remark: _vm.currentRemarkObj.remark
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.remarkDialogVisible = $event;
      },
      getData: _vm.getData
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };